import React, { Component } from 'react';
import Popup from 'reactjs-popup';
import whiteLoader from '../../assets/images/white_preloader_s.gif';

const overlayStyle = { background: 'rgba(0,0,0,0.5)' };
const contentStyle = { background: 'transparent', width: 'fit-content', border: 'none' };
class PreLoader extends Component {
  render() {
    return (
      <Popup open closeOnEscape={false} closeOnDocumentClick={false} {...{ contentStyle, overlayStyle }}>
        <img src={whiteLoader} />
      </Popup>

    );
  }
}

export default PreLoader;
